import { useLocation } from 'react-router';

/**
 * Where a list page is right now, query string included: pass it as `state={{ from }}` on every link
 * from a row (and every "New" button), so the detail or edit page can return to the grid as it was.
 */
export function useListHref(): string {
  const { pathname, search } = useLocation();
  return pathname + search;
}

/**
 * Where a detail or edit page's "Back to …" link and Cancel go: the list as it was left when the page
 * was opened from it (`state.from`), else the bare list path (a direct open, a reload that lost the
 * state, a link from another page). `from` is used only when it is the list path or that path plus a
 * query, so a forged state cannot send the link anywhere else.
 */
export function useBackHref(listPath: string): string {
  const { state } = useLocation();
  const from = (state as { from?: unknown } | null)?.from;
  return typeof from === 'string' && (from === listPath || from.startsWith(`${listPath}?`)) ? from : listPath;
}
